import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {StyleFields} from 'Event/auth/Login/SubmitButton/SubmitButtonConfig'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useAttendeeVariables} from 'Event'
import {replaceAtPath} from 'lib/JsonUpdateProvider'

export default function SubmitButtonConfig() {
  const saveTemplate = useSaveTemplate()
  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()
  const {login} = useTemplate()

  const save = (data: any) => {
    const buttonText = replaceAtPath(
      data,
      'login.passwordReset.buttonText',
      '{{password_reset_button_text}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        password_reset_button_text: buttonText ?? '',
      }),
    })
  }

  const {
    form: {register},
  } = useConfig()

  return (
    <Config title="Submit Button" onSave={save}>
      <SettingsPanel>
        <TextField
          label="Submit Label"
          name="login.passwordReset.buttonText"
          defaultValue={v(login.passwordReset.buttonText)}
          inputProps={{
            'aria-label': 'submit button label',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <StyleFields />
      </StylingPanel>
    </Config>
  )
}
